// Neobrutalism Theme Configuration
import type { Theme } from './types';
import { buildThemeCssVarMap, themeVarMapToCss } from './tokens';

export const neobrutalismTheme: Theme = {
    name: 'neobrutalism',
    colors: {
        // Primary - Emerald
        primary: '#10b981', // emerald-500
        primaryHover: '#34d399', // emerald-400
        primaryActive: '#059669', // emerald-600

        // Secondary - Gray
        secondary: '#f3f4f6', // gray-100
        secondaryHover: '#f9fafb', // gray-50
        secondaryActive: '#e5e7eb', // gray-200

        // Backgrounds
        background: '#ffffff',
        surface: '#ffffff',
        surfaceHover: '#f9fafb', // gray-50

        // Text
        text: '#0f172a', // slate-900
        textMuted: '#64748b', // slate-500
        textInverse: '#ffffff',

        // Borders
        border: '#000000',
        borderLight: '#e2e8f0', // slate-200

        // Status
        success: '#10b981', // emerald-500
        warning: '#f59e0b', // amber-500
        error: '#ef4444', // red-500
        info: '#0ea5e9', // sky-500
    },
    effects: {
        // Border
        borderWidth: '2px',
        borderRadius: '12px', // rounded-xl
        borderRadiusSmall: '8px', // rounded-lg
        borderRadiusLarge: '16px', // rounded-2xl

        // Shadows - Hard, offset, no blur
        shadow: '4px 4px 0px 0px rgb(17, 24, 39)',
        shadowHover: '4px 4px 0px 0px rgb(17, 24, 39)',
        shadowActive: 'none',

        // No blur for neobrutalism
        blur: 'none',

        // Transitions - Snappy
        transition: 'all 200ms ease-out',
        transitionFast: 'all 150ms ease-out',

        // Hover transforms
        hoverTranslateX: '-4px',
        hoverTranslateY: '-4px',
    },
};

// CSS variables for neobrutalism theme
export const neobrutalismCSSVarMap = buildThemeCssVarMap(neobrutalismTheme);
export const neobrutalismCSSVars = themeVarMapToCss(neobrutalismCSSVarMap);
